
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M36 32a4 4 0 11-8.002-.002A4 4 0 0136 32z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M44.03 3a16.968 16.968 0 00-12 4.971L20.708 19.293l4 4-1.414 1.414-4-4L7.971 32.029a16.97 16.97 0 00-4.971 12C3 53.402 10.598 61 19.971 61a16.97 16.97 0 0012-4.971l11.322-11.322-4-4 1.414-1.414 4 4L56.03 31.971a16.973 16.973 0 004.97-12C61 10.598 53.402 3 44.03 3zm-9.879 7.092a14.058 14.058 0 013.382-2.498l.933 1.77a12.061 12.061 0 00-2.901 2.143l-3.201 3.201-1.414-1.414 3.201-3.202zM38 32c0 .736-.139 1.437-.381 2.089l1.81 1.045.5-.866 1.732 1-2 3.465-1.732-1 .5-.866-1.805-1.042A5.998 5.998 0 0133 37.91V40h1v2h-4v-2h1v-2.09a5.994 5.994 0 01-3.623-2.086l-1.805 1.042.5.866-1.732 1-2-3.465 1.732-1 .5.866 1.81-1.045C26.139 33.437 26 32.736 26 32s.139-1.437.381-2.089l-1.81-1.045-.5.866-1.732-1 2-3.465 1.732 1-.5.866 1.805 1.042a5.994 5.994 0 013.623-2.086V24h-1v-2h4v2h-1v2.09a5.994 5.994 0 013.623 2.086l1.805-1.042-.5-.866 1.732-1 2 3.465-1.732 1-.5-.866-1.81 1.045A5.93 5.93 0 0138 32zm6.029-24c-.947 0-1.888.109-2.797.326l-.464-1.945A14.087 14.087 0 0144.029 6v2z"}})])
          )
        }
      }
    